<template>
  <div class="flex flex-col mt-8 font-sans-serif bg-white h-auto w-full px-10 mb-10">
    <form @submit.prevent="saveData">
      <div class="border-b-2 border-orange-academy-150 pb-2 text-lg flex justify-between
      font-medium items-center">
        <h1 class="text-lg">{{$t('skills.personal-information')}}</h1>
        <button class="w-auto text-orange-academy-300 mr-3 transform hover:scale-105"
          v-if="showSaveButton" >
            <save-icon class="w-6"></save-icon>
        </button>
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input :name="$t('skills.firstname')" class="w-full pr-4"
        v-model="editedStudent.firstname" @input="onInputData('firstname')" :is-required="true" />
        <material-input class="w-full" v-model="editedStudent.lastname"
        @input="onInputData('lastname')" :name="$t('skills.lastname')" :is-required="true" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input :name="$t('skills.address')"  v-model="editedStudent.address"
        @input="onInputData('address')" class="w-full" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input class="w-full pr-4" v-model="editedStudent.city"
        @input="onInputData('city')" :name="$t('skills.city')"/>
        <material-input class="w-full" v-model="editedStudent.postcode"
        @input="onInputData('postcode')" :name="$t('skills.postcode')" />
      </div>
        <span class="text-red-500"
          v-if="errors.has('postcode')"
          v-text="errors.get('postcode')"
        >
        </span>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input class="w-full pr-4" v-model="editedStudent.state"
        @input="onInputData('state')" :name="$t('skills.state')"/>
        <span class="text-red-500"
          v-if="errors.has('state')"
          v-text="errors.get('state')"
        >
        </span>
        <material-input  class="w-full" v-model="editedStudent.country"
        @input="onInputData('country')" :name="$t('skills.country')" />
        <span class="text-red-500"
          v-if="errors.has('country')"
          v-text="errors.get('country')"
        >
        </span>
      </div>
      <div class="flex mt-10 w-full justify-between items-end">
        <material-input :name="$t('skills.phone')" class="w-full pr-4"
          v-model="editedStudent.phone" @input="onInputData('phone')" />
        <span class="text-red-500"
          v-if="errors.has('phone')"
          v-text="errors.get('phone')"
        >
        </span>
        <material-input :name="$t('skills.age')" type="text" class="w-full"
        v-model="editedStudent.age"
        @input="onInputData('age')"/>
        <span class="text-red-500"
          v-if="errors.has('age')"
          v-text="errors.get('age')"
        >
        </span>
      </div>
      <div class="flex mt-10 w-full justify-between items-end">
        <material-input :name="$t('skills.educationalTitle')" class="w-full"
          v-model="editedStudent.qualification" @input="onInputData('qualification')" />
      </div>
    </form>
    <div class="flex flex-col mt-16">
      <div class="border-b-2 border-orange-academy-150 pb-2 text-lg flex justify-start
      font-medium">
        {{$t('skills.studies')}}
      </div>
      <div class="flex flex-col items-start mt-6 w-full">
        <school-row
          v-for="school in schools"
          :key="school.id"
          :school="school"
          @updated="somethingHasBeenUpdated" />
        <add-new-school v-model="addSchool" @school-added="somethingHasBeenUpdated" />
      </div>
    </div>
    <div class="flex flex-col mt-16">
      <div class="border-b-2 border-orange-academy-150 pb-2 text-lg flex justify-start
        font-medium">
          {{ $t('skills.instruments') }}
      </div>
      <div class="flex flex-col items-start mt-6 w-full">
        <instrument-row
          v-for="instrument in instruments"
          :key="instrument.id"
          :instrument="instrument"
          @updated="somethingHasBeenUpdated" />
        <add-new-instrument v-model="addInstrument"
          @instrument-added="somethingHasBeenUpdated"
          :instruments="instruments"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Errors from '@/util/Errors';
import AlgoliaMixin from '@/mixins/AlgoliaMixin';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import { updateStudentData, getStudentSchools, getStudentInstruments } from '@/services/StudentService';
import MaterialInput from '../graphics/MaterialInput.vue';
import SchoolRow from '../SchoolRow.vue';
import InstrumentRow from '../InstrumentRow.vue';
import SaveIcon from '../graphics/SaveIcon.vue';
import AddNewSchool from '../AddNewSchool.vue';
import AddNewInstrument from '../AddNewInstrument.vue';

export default {
  components: {
    MaterialInput,
    SchoolRow,
    InstrumentRow,
    SaveIcon,
    AddNewSchool,
    AddNewInstrument,
  },

  data() {
    return {
      editedStudent: {
        firstname: '',
        lastname: '',
        address: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
        age: '',
        phone: '',
        qualification: '',
      },

      schools: [],
      addSchool: false,

      instruments: [],
      addInstrument: false,

      showSaveButton: false,
      errors: new Errors(),
    };
  },

  mounted() {
    Object.keys(this.editedStudent).forEach((key) => {
      this.editedStudent[key] = this.student[key];
    });
    if (this.editedStudent.age) {
      this.editedStudent.age = this.editedStudent.age.toString();
    }
  },

  computed: {
    ...mapGetters({
      student: 'auth/student',
      user: 'auth/user',
    }),
  },

  mixins: [AlgoliaMixin, StreamFunctionsMixin],

  created() {
    this.getSchools();
    this.getInstruments();
  },

  methods: {
    onInputData(field) {
      this.errors.clear(field);
      this.showSaveButton = true;
    },
    getSchools() {
      getStudentSchools(this.user.id).then(({ data }) => {
        this.schools = data;
      });
    },

    getInstruments() {
      getStudentInstruments(this.student.id).then(({ data }) => {
        this.instruments = data;
      });
    },

    saveData() {
      updateStudentData(this.student.id, this.editedStudent).then(() => {
        this.showSaveButton = false;
        this.createNotification('success', this.$t('skills.success'));
      }).catch(({ response: { data: { errors } } }) => {
        this.errors.record(errors);
      });
    },

    somethingHasBeenUpdated() {
      this.getSchools();
      this.getInstruments();
      this.reset();
    },

    reset() {
      this.addSchool = false;
      this.addInstrument = false;
    },

  },
};
</script>
